var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-tent"},[_c('div',{staticClass:"box-tent-tit"},[_c('h3',[_vm._v(_vm._s(_vm.screenName))])]),_vm._v(" "),_c('div',{staticClass:"echartsy",attrs:{"id":'chartline' + _vm.echartId}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// D:/ADO_CICD/tools/nodejs/portal/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-565ca4fd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!D:/ADO_CICD/tools/nodejs/portal/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ale/modules/screen3.vue
// module id = null
// module chunks = 